import { render, staticRenderFns } from "./ColourSettingsPicker.vue?vue&type=template&id=23b115c6&scoped=true"
import script from "./ColourSettingsPicker.vue?vue&type=script&lang=js"
export * from "./ColourSettingsPicker.vue?vue&type=script&lang=js"
import style0 from "./ColourSettingsPicker.vue?vue&type=style&index=0&id=23b115c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b115c6",
  null
  
)

export default component.exports